module.exports = __webpack_public_path__ + "img/DSC_2889-xs.39b28d36.png";